export default {
	tryTeamingTitle: "Sign up with your work email to start your free, 14-day trial.",
	signUpTitle: "Sign up for Teaming",
	googleSignUpButton: "Sign up with Google",
	microsoftSignUpButton: "Sign up with Microsoft",
	emailSignUpButton: "Sign up with Email",
	alreadyHaveAccountText: "Already have a Teaming account?",
	signInText: "Sign in.",
	footer: "By signing up and creating an account, you agree to the <a href='{termsOfServiceLink}'>Terms of Service</a> and <a href='{privacyPolicyLink}'>Privacy Policy</a>. You also agree to receive information and offers relevant to our services via email. You can opt-out of these emails at any time.",
	infoTitle: "Everything you need to lead your team.",
	infoItem1: "Use one on ones for Coaching and Development",
	infoItem2: "Align your team with Goals and Key Results",
	infoItem3: "Keep track of action items with Team Meetings",
	infoItem4: "Bridge the gap in communication with Personality Profiles",
	infoItem5: "Measure and improve Team Health",
	infoFooter: "Teaming’s meeting features currently require authentication with your GSuite or Office 365 account.",
};
